import React from "react";
import { DISCLAIMER_TEXT } from "@/components/layout/Footer";

const SECTIONS = [
  {
    title: "1. About Sponsor Me",
    body: [
      "Sponsor Me is an independent peer-connection service that helps people in recovery find others willing to offer peer sponsorship or mentorship. We are not a treatment provider, a medical service, a crisis service, or a recovery fellowship.",
      DISCLAIMER_TEXT,
    ],
  },
  {
    title: "2. Who may use Sponsor Me",
    body: [
      "You must be at least 18 years old to create an account. You agree to provide accurate information about yourself and not to impersonate another person or organization.",
    ],
  },
  {
    title: "3. Peer support is not professional care",
    body: [
      "Sponsors and members on this platform are peers. They are not emergency responders, therapists, doctors, counselors, or licensed professionals acting in that capacity. Nothing shared on Sponsor Me is medical advice.",
      "If you are in immediate danger or crisis, contact your local emergency services or a crisis line. Our Resources page lists free crisis contacts by country.",
    ],
  },
  {
    title: "4. Prohibited behavior",
    list: [
      "Selling drugs or offering to supply any controlled substance",
      "Buying or soliciting drugs",
      "Asking other members for money, gifts, or loans",
      "Financial scams, fraud, or any money-making scheme",
      "Sexual exploitation, solicitation, or sexual content directed at another member",
      "Threats, intimidation, stalking, or harassment of any kind",
      "Impersonating another person, a sponsor, or an organization",
      "Offering medical diagnosis, prescriptions, or clinical treatment",
      "Pretending to represent or speak for AA, NA, CMA, SMART Recovery or any fellowship",
      "Advertising treatment centers, sober homes or services without authorization",
      "Sharing another person's private information, photos, or recovery status",
    ],
    body: [
      "Accounts that violate these rules may be warned, suspended or permanently banned at our discretion. Serious violations may be reported to the appropriate authorities.",
    ],
  },
  {
    title: "5. Safety tools",
    body: [
      "Every conversation includes Block and Report. Blocking and reporting are always free and never require a membership. Reported accounts and messages enter a moderation queue for human review.",
    ],
  },
  {
    title: "6. Memberships and billing",
    body: [
      "Browsing sponsor profiles is free forever. Sponsor accounts are free forever, including unlimited messaging. Members looking for a sponsor receive 20 free sent messages. Messages you receive never count against that balance.",
      "After the free messages are used, continued messaging requires a membership: $1.99 per week, $4.99 per month, or $29.99 per year. All plans include unlimited messaging.",
      "All subscriptions renew automatically until canceled. Your subscription automatically renews unless canceled before your next billing date. There are no hidden charges. You can cancel at any time from your dashboard or the Stripe billing portal, and you keep access until the end of your paid period.",
      "Payments are processed by Stripe. We never store your card details.",
    ],
  },
  {
    title: "7. Free access",
    body: [
      "If you cannot afford a membership, you may request a 7-Day Recovery Access Pass once per account. No credit card is required. We would rather you stay connected than lose a recovery relationship over the price of a membership.",
    ],
  },
  {
    title: "8. Account deletion",
    body: [
      "You may delete your account at any time from Profile and Settings. Deletion removes your profile from the directory, ends your connections and anonymises your account. Cancel any active membership before deleting so you are not billed again.",
    ],
  },
  {
    title: "9. Limitation of liability",
    body: [
      "Sponsor Me provides a platform for members to find each other. We do not verify members' recovery history, identity, or intentions, and we are not responsible for the conduct of any member. You use the platform and connect with other members at your own discretion and risk.",
    ],
  },
  {
    title: "10. Changes to these terms",
    body: [
      "We may update these terms from time to time. We will highlight material changes in the app. Continuing to use Sponsor Me after an update means you accept the revised terms.",
    ],
  },
];

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <h1 className="font-display text-4xl font-bold text-[#1F2A2E]">Terms of Service</h1>
      <p className="mt-2 text-sm text-[#7A868B]">Last updated {new Date().toLocaleDateString()}</p>
      <div className="mt-8 space-y-8">
        {SECTIONS.map((s) => (
          <section key={s.title}>
            <h2 className="font-display text-xl font-bold text-[#1F2A2E]">{s.title}</h2>
            {s.list ? (
              <ul className="mt-3 space-y-1.5 list-disc pl-5 text-[#4B5A60] leading-7">
                {s.list.map((l) => (
                  <li key={l}>{l}</li>
                ))}
              </ul>
            ) : null}
            {(s.body || []).map((p, i) => (
              <p key={`${s.title}-p${i}`} className="mt-3 text-[#4B5A60] leading-7">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </div>
  );
}
